import Helper from './Helper';

class CookiesExtended {
  constructor() {
      this.cookieBanner = document.querySelector('.cookies-extended');
      this.body = document.querySelector('body');
      if(!!this.cookieBanner){
        this.cookieSettings = document.querySelector('.cookie-settings-backdrop');
        
        const cookie = Helper.getCookie('extended-cookies');
        if(!cookie){
          this.content = document.querySelector('.content');
          this.header = document.querySelector('.header');
          this.showBanner();
        }

        document.querySelector('#js-accept-all-cookies').addEventListener('click', () => {
          Helper.setCookie('extended-cookies', 'all', 180);
          this.hideBanner();
        });
        
        document.querySelector('#js-accept-necessary-cookies').addEventListener('click', () => {
          Helper.setCookie('extended-cookies', 'necessary', 180);
          this.hideBanner();
        });
        
        const settingsButtons = Array.prototype.slice.call(document.querySelectorAll('.js-cookie-settings'));
        settingsButtons.forEach(button => { 
          button.addEventListener('click', () => {
            this.showSettings();
          });
        });
        
        const closeButtons = Array.prototype.slice.call(document.querySelectorAll('.js-cookie-settings-close'));
        closeButtons.forEach(button => { 
          button.addEventListener('click', () => {
            this.hideSettings();
          });
        });
        
        document.querySelector('.cookie-settings-backdrop').addEventListener('click', (e) => {
          if(e.target.classList.contains('cookie-settings-backdrop')){
            this.hideSettings();
          }
        });
        const checkbox = document.querySelector('.cookie-settings__checkbox');
        document.querySelector('#js-save-cookies').addEventListener('click', (e) => {
          /*if(checkbox.checked){
            Helper.setCookie('extended-cookies', 'all', 180);
          } else{
            Helper.setCookie('extended-cookies', 'necessary ', 180);
          }*/
          this.hideBanner();
          this.hideSettings();
        });
      }
  }

  hideBanner(){
    this.cookieBanner.style.display = 'none';
    if(!!this.header) this.header.style.marginTop = 0;
    if(!Helper.isDesktop()) {
      this.content.style.marginTop = 0;
    }
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
  showBanner(){
    this.cookieBanner.style.display = 'block';
    this.header.style.marginTop = this.cookieBanner.clientHeight + 'px';
    if(!Helper.isDesktop()) {
      this.content.style.marginTop = this.cookieBanner.clientHeight + 'px';
    }
  }

  showSettings(){
    this.cookieSettings.style.display = 'block';
    this.body.classList.add('cookie-settings-open');
    //const cookiesettingscheckbox = document.querySelector('.cookie-settings__checkbox');
    /*if(Helper.getCookie('extended-cookies') == 'all'){
      cookiesettingscheckbox.checked = true;
    } else{
      cookiesettingscheckbox.checked = false;
    }*/
  }
  
  hideSettings(){
    this.cookieSettings.style.display = 'none';
    this.body.classList.remove('cookie-settings-open');
  }


} export default CookiesExtended;
